export default __webpack_public_path__ + "static/media/Group1489.8590593c.png";